/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../../types/graph';

import * as Operations from './mutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SubmitCommonAppMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.LifeApplicationSubmitCommonAppMutationInput;
}>;


export type SubmitCommonAppMutation = { __typename?: 'Mutation', life_applications: { __typename?: 'LifeApplications', submit_common_app: { __typename?: 'LifeApplication', id: string } | null } };


export function useSubmitCommonAppMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCommonAppMutation, SubmitCommonAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCommonAppMutation, SubmitCommonAppMutationVariables>(Operations.SubmitCommonApp, options);
      }
export type SubmitCommonAppMutationHookResult = ReturnType<typeof useSubmitCommonAppMutation>;